import { Flex, Separator, Button } from "@shared/primitive-components"
import { InfoPane, InfoPaneProps } from "../InfoPane"
import * as styles from "./detailsStyles"

interface DetailsProps extends InfoPaneProps {
  readonly actions?: ReadonlyArray<Action>
}

export type Action = Readonly<{
  title: string
  onClick: () => void
}>

export const Details = (props: DetailsProps) => {
  const { title, summary, css, children, actions } = props

  return (
    <InfoPane title={title} summary={summary} css={css}>
      <>
        <Separator size="hairlineFull" color="gray" />

        {children}

        {actions && (
          <>
            <Separator size="hairlineFull" color="gray" />

            <Flex flexDirection="row-reverse" justifyContent="space-between" css={styles.buttonWrap}>
              {actions.map(({ title: actionTitle, onClick }) => (
                <Button key={title + actionTitle} onClick={onClick} css={styles.button}>
                  {actionTitle}
                </Button>
              ))}
            </Flex>
          </>
        )}
      </>
    </InfoPane>
  )
}

Details.defaultProps = {
  actions: undefined,
}
